import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { scrollToElement } from '../utils/scrollToElement';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-189">
      {visible && <motion.button initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.45,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} whileHover={{
      scale: 1.01
    }} whileTap={{
      scale: 0.99
    }} onClick={() => scrollToElement('precio')} className="fixed bottom-4 md:bottom-6 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-auto md:min-w-[320px] z-40 bg-bordo hover:bg-bordo-dark text-cream px-5 md:px-10 py-4 md:py-5 shadow-soft-lg flex items-center justify-center gap-2 md:gap-3 group transition-colors duration-300" aria-label="Comenzar ahora" data-id="element-190">
          <span className="uppercase tracking-[0.12em] md:tracking-[0.18em] text-xs md:text-sm font-medium whitespace-nowrap" data-id="element-191">
            Comenzar Ahora
          </span>
          <ArrowRight strokeWidth={1.5} className="w-4 h-4 flex-shrink-0 transition-transform duration-300 group-hover:translate-x-1" data-id="element-192" />
        </motion.button>}
    </AnimatePresence>;
}